/* lno-midnight-pdp-bp · update 3 */
/* Nitric Oxide Flow — product page concept C.
   Bundle picker, add to cart (subscription + free ebook, straight to checkout),
   ship date, tabs, gallery, videos, sticky bar, scroll buttons. No libraries. */
(function () {
  'use strict';
  if (window.__nofcLoaded) return;
  window.__nofcLoaded = true;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var state = { config: null, selected: 0 };

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function once(el, key) {
    var k = '__nofc_' + key;
    if (el[k]) return false;
    el[k] = true;
    return true;
  }
  function track(name, data) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: name }, data || {}));
  }

  /* ---------- config from the hero section ---------- */
  function readConfig() {
    var el = $('[data-nofc-config]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  /* ---------- bundle picker ---------- */
  function selectBundle(index, focus) {
    state.selected = index;
    $$('[data-nofc-bundle]').forEach(function (btn) {
      var on = Number(btn.getAttribute('data-nofc-bundle')) === index;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-checked', on ? 'true' : 'false');
      btn.tabIndex = on ? 0 : -1;
      if (on && focus) btn.focus();
    });
    updateSticky();
  }

  function initBundles() {
    var btns = $$('[data-nofc-bundle]');
    if (!btns.length) return;
    var start = btns.findIndex(function (b) { return b.classList.contains('is-selected'); });
    selectBundle(start < 0 ? 0 : Number(btns[start].getAttribute('data-nofc-bundle')));
    btns.forEach(function (btn) {
      if (!once(btn, 'bundle')) return;
      btn.addEventListener('click', function () { selectBundle(Number(btn.getAttribute('data-nofc-bundle'))); });
      btn.addEventListener('keydown', function (e) {
        var i = Number(btn.getAttribute('data-nofc-bundle'));
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') { e.preventDefault(); selectBundle((i + 1) % btns.length, true); }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') { e.preventDefault(); selectBundle((i - 1 + btns.length) % btns.length, true); }
      });
    });
  }

  /* ---------- add to cart ---------- */
  function fetchJSON(url, body) {
    return fetch(root.replace(/\/$/, '') + url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body ? JSON.stringify(body) : undefined
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
        return j;
      });
    });
  }

  function addBundle(index, button) {
    var cfg = state.config || { bundles: [] };
    var errorEl = button.parentNode.querySelector('[data-nofc-error]');
    if (errorEl) errorEl.textContent = '';
    var b;
    if (button.hasAttribute('data-variant')) {
      // A starter kit card with its own product
      b = {
        variant: button.getAttribute('data-variant'),
        plan: button.getAttribute('data-plan'),
        ebook: button.getAttribute('data-ebook') === 'true',
        name: button.getAttribute('data-name') || ''
      };
    } else {
      b = cfg.bundles && cfg.bundles[index];
    }
    if (!b || !b.variant) {
      if (errorEl) errorEl.textContent = "This option isn't connected to a product yet.";
      return;
    }
    var ourIds = (cfg.bundles || []).map(function (x) { return String(x.variant); }).filter(Boolean);
    $$('[data-nofc-add][data-variant]').forEach(function (x) { if (x.getAttribute('data-variant')) ourIds.push(String(x.getAttribute('data-variant'))); });
    if (cfg.ebookVariant) ourIds.push(String(cfg.ebookVariant));

    var item = { id: Number(b.variant), quantity: 1 };
    if (b.plan) item.selling_plan = Number(b.plan);
    var items = [item];
    if (b.ebook && cfg.ebookVariant) items.push({ id: Number(cfg.ebookVariant), quantity: 1 });

    button.setAttribute('aria-busy', 'true');
    track('nofc_add_to_cart', { bundle: b.name, variant: b.variant });

    // Remove any bundle or ebook already in the cart, so there is never more than one.
    fetchJSON('/cart.js').then(function (cart) {
      var updates = {};
      var any = false;
      cart.items.forEach(function (line) {
        if (ourIds.indexOf(String(line.variant_id)) !== -1) { updates[line.key] = 0; any = true; }
      });
      return any ? fetchJSON('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      return fetchJSON('/cart/add.js', { items: items });
    }).then(function () {
      window.location.href = root.replace(/\/$/, '') + (cfg.afterAdd === 'cart' ? '/cart' : '/checkout');
    }).catch(function (err) {
      button.removeAttribute('aria-busy');
      if (errorEl) errorEl.textContent = err.message;
    });
  }

  function initAdd() {
    $$('[data-nofc-add]').forEach(function (btn) {
      if (!once(btn, 'add')) return;
      btn.addEventListener('click', function () {
        var v = btn.getAttribute('data-nofc-add');
        addBundle(v === 'selected' ? state.selected : Number(v), btn);
      });
    });
  }

  /* ---------- ship date ---------- */
  function initShip() {
    var bar = $('[data-nofc-ship]');
    if (!bar) return;
    var cutoff = Number(bar.getAttribute('data-cutoff') || 14);
    var tz = bar.getAttribute('data-tz') || undefined;
    var now = new Date();
    var parts;
    try {
      parts = new Intl.DateTimeFormat('en-US', { timeZone: tz, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(now);
    } catch (e) {
      parts = new Intl.DateTimeFormat('en-US', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', hourCycle: 'h23' }).formatToParts(now);
    }
    var p = {};
    parts.forEach(function (x) { p[x.type] = x.value; });
    var today = new Date(Number(p.year), Number(p.month) - 1, Number(p.day));
    var ship = new Date(today);
    if (Number(p.hour) >= cutoff) ship.setDate(ship.getDate() + 1);
    if (ship.getDay() === 6) ship.setDate(ship.getDate() + 2);
    if (ship.getDay() === 0) ship.setDate(ship.getDate() + 1);
    var diff = Math.round((ship - today) / 86400000);
    var label;
    if (diff === 0) label = bar.getAttribute('data-today') || 'today';
    else if (diff === 1) label = (bar.getAttribute('data-tomorrow') || 'tomorrow') + ', ' + ship.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    else label = ship.toLocaleDateString('en-US', { weekday: 'long', month: 'short', day: 'numeric' });
    var out = $('[data-nofc-ship-label]', bar);
    if (out) out.textContent = label;
  }

  /* ---------- gallery: swipe / arrows / thumbnails ---------- */
  function initGallery() {
    $$('[data-nofc-gal]').forEach(function (g) {
      if (!once(g, 'gal')) return;
      var track = $('[data-nofc-gal-track]', g);
      if (!track) return;
      var slides = $$('.nofc-gal__slide', track);
      var thumbs = $$('[data-nofc-gal-thumb]', g);
      var count = slides.length;
      var current = 0;
      function setActive(i) {
        current = i;
        thumbs.forEach(function (t, k) {
          var on = k === i;
          t.classList.toggle('is-active', on);
          if (on) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
        });
      }
      function go(i) {
        i = (i + count) % count;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
        setActive(i);
      }
      var t;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () {
          var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
          if (i !== current && i >= 0 && i < count) setActive(i);
        }, 60);
      }, { passive: true });
      var prev = $('[data-nofc-gal-prev]', g), next = $('[data-nofc-gal-next]', g);
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      thumbs.forEach(function (th) {
        th.addEventListener('click', function () { go(Number(th.getAttribute('data-nofc-gal-thumb'))); });
      });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
      });
      window.addEventListener('resize', function () { track.scrollLeft = slides[current].offsetLeft; });
    });
  }

  /* ---------- videos ---------- */
  function openVideo(src, kind) {
    if (!src) return;
    var wrap = document.createElement('div');
    wrap.className = 'nofc-modal';
    wrap.setAttribute('role', 'dialog');
    wrap.setAttribute('aria-modal', 'true');
    var box = document.createElement('div');
    box.className = 'nofc-modal__box';
    var media;
    if (kind === 'youtube' || kind === 'vimeo') {
      box.classList.add('is-wide');
      media = document.createElement('iframe');
      media.src = kind === 'youtube' ? 'https://www.youtube.com/embed/' + src + '?autoplay=1&rel=0' : 'https://player.vimeo.com/video/' + src + '?autoplay=1';
      media.allow = 'autoplay; fullscreen; picture-in-picture';
      media.allowFullscreen = true;
      media.title = 'Customer video';
    } else {
      media = document.createElement('video');
      media.src = src; media.controls = true; media.autoplay = true; media.playsInline = true;
    }
    var close = document.createElement('button');
    close.type = 'button'; close.className = 'nofc-modal__close'; close.setAttribute('aria-label', 'Close video'); close.textContent = '×';
    box.appendChild(close); box.appendChild(media); wrap.appendChild(box);
    function shut() { wrap.remove(); document.removeEventListener('keydown', onKey); }
    function onKey(e) { if (e.key === 'Escape') shut(); }
    close.addEventListener('click', shut);
    wrap.addEventListener('click', function (e) { if (e.target === wrap) shut(); });
    document.addEventListener('keydown', onKey);
    document.body.appendChild(wrap);
    close.focus();
    track('nofc_video_play', { kind: kind });
  }

  function initVideos() {
    $$('[data-nofc-video]').forEach(function (b) {
      if (!once(b, 'video')) return;
      b.addEventListener('click', function () { openVideo(b.getAttribute('data-nofc-video'), b.getAttribute('data-kind')); });
    });
    $$('[data-nofc-strip-next]').forEach(function (n) {
      if (!once(n, 'next')) return;
      var strip = n.parentNode.querySelector('[data-nofc-strip]');
      n.addEventListener('click', function () {
        if (!strip) return;
        var atEnd = strip.scrollLeft + strip.clientWidth >= strip.scrollWidth - 4;
        strip.scrollTo({ left: atEnd ? 0 : strip.scrollLeft + strip.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
  }

  /* ---------- lab certificate popup ---------- */
  function initCoa() {
    $$('[data-nofc-coa]').forEach(function (btn) {
      if (!once(btn, 'coa')) return;
      var tpl = btn.parentNode.querySelector('template[data-nofc-coa-pages]');
      if (!tpl) return;
      btn.addEventListener('click', function () {
        var wrap = document.createElement('div');
        wrap.className = 'nofc-modal';
        wrap.setAttribute('role', 'dialog');
        wrap.setAttribute('aria-modal', 'true');
        wrap.appendChild(tpl.content.cloneNode(true));
        var title = wrap.querySelector('.nofc-coa-box__title');
        if (title) { title.id = 'nofc-coa-title'; wrap.setAttribute('aria-labelledby', 'nofc-coa-title'); }
        function shut() {
          wrap.remove();
          document.body.classList.remove('nofc-lock');
          document.removeEventListener('keydown', onKey);
          btn.focus();
        }
        function onKey(e) { if (e.key === 'Escape') shut(); }
        wrap.addEventListener('click', function (e) { if (e.target === wrap || e.target.closest('[data-nofc-modal-close]')) shut(); });
        document.addEventListener('keydown', onKey);
        document.body.appendChild(wrap);
        document.body.classList.add('nofc-lock');
        var close = wrap.querySelector('[data-nofc-modal-close]');
        if (close) close.focus();
        track('nofc_coa_open');
      });
    });
  }

  /* ---------- tabs ---------- */
  function showTab(container, name) {
    $$('[data-nofc-tab]', container).forEach(function (t) {
      t.setAttribute('aria-selected', t.getAttribute('data-nofc-tab') === name ? 'true' : 'false');
      t.tabIndex = t.getAttribute('data-nofc-tab') === name ? 0 : -1;
    });
    $$('[data-nofc-panel]', container).forEach(function (p) { p.hidden = p.getAttribute('data-nofc-panel') !== name; });
  }
  function initTabs(scope) {
    $$('[data-nofc-tabs]', scope).forEach(function (c) {
      var tabs = $$('[data-nofc-tab]', c);
      tabs.forEach(function (t, i) {
        if (!once(t, 'tab')) return;
        t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
        t.addEventListener('click', function () { showTab(c, t.getAttribute('data-nofc-tab')); });
        t.addEventListener('keydown', function (e) {
          var d = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
          if (!d) return;
          var n = tabs[(i + d + tabs.length) % tabs.length];
          showTab(c, n.getAttribute('data-nofc-tab')); n.focus();
        });
      });
    });
  }

  /* ---------- scroll buttons ---------- */
  function scrollToTarget(target) {
    function y() { return target.getBoundingClientRect().top + window.pageYOffset - 16; }
    window.scrollTo({ top: y(), behavior: reduceMotion ? 'auto' : 'smooth' });
    // Mobile browsers can drift while scrolling (images loading, toolbars resizing): correct once it settles.
    setTimeout(function () {
      var d = target.getBoundingClientRect().top - 16;
      if (Math.abs(d) > 4) window.scrollTo({ top: y(), behavior: 'auto' });
    }, 900);
  }
  function initScroll() {
    $$('[data-nofc-scroll]').forEach(function (a) {
      if (!once(a, 'scroll')) return;
      a.addEventListener('click', function (e) {
        var target = $(a.getAttribute('data-nofc-scroll'));
        if (!target) return;
        e.preventDefault();
        e.stopImmediatePropagation(); // stop the theme's own anchor-link scripts from also scrolling
        scrollToTarget(target);
        if (!('ontouchstart' in window)) {
          var focusEl = $('.is-selected, button', target);
          if (focusEl) { try { focusEl.focus({ preventScroll: true }); } catch (err) { /* older browsers */ } }
        }
        track('nofc_cta_scroll', { target: a.getAttribute('data-nofc-scroll') });
      }, true);
    });
  }

  /* ---------- sticky bar + back to top ---------- */
  var sticky, totop, buyVisible = false;
  function updateSticky() {
    if (!sticky || !state.config || !state.config.bundles) return;
    var b = state.config.bundles[state.selected];
    if (!b) return;
    var n = $('[data-nofc-sticky-name]', sticky), p = $('[data-nofc-sticky-price]', sticky);
    if (n) n.textContent = b.name;
    if (p) p.textContent = b.price;
  }
  function onScroll() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    var pct = max > 0 ? window.scrollY / max : 0;
    if (sticky) {
      var after = Number(sticky.getAttribute('data-after') || 30) / 100;
      var hideNear = sticky.getAttribute('data-hide-near-buy') === 'true';
      var show = pct >= after && !(hideNear && buyVisible);
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      var btn = $('button', sticky); if (btn) btn.tabIndex = show ? 0 : -1;
      document.body.classList.toggle('nofc-has-sticky', show);
    }
    if (totop) totop.classList.toggle('is-visible', window.scrollY > window.innerHeight * 1.5);
  }
  function initSticky() {
    sticky = $('[data-nofc-sticky]');
    totop = $('[data-nofc-totop]');
    if (sticky && 'IntersectionObserver' in window) {
      var targets = $$('.nofc-bundles, [data-nofc-kit] .nofc-kit__cards');
      var seen = new Map();
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
        buyVisible = Array.from(seen.values()).some(Boolean);
        onScroll();
      });
      targets.forEach(function (t) { io.observe(t); });
    }
    if (totop && once(totop, 'totop')) totop.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' }); });
    var ticking = false;
    if (once(window, 'scroll')) window.addEventListener('scroll', function () {
      if (ticking) return; ticking = true;
      requestAnimationFrame(function () { ticking = false; onScroll(); });
    }, { passive: true });
    updateSticky();
    onScroll();
  }

  /* ---------- theme editor: show the tab of the block being edited ---------- */
  function initEditor() {
    if (!(window.Shopify && window.Shopify.designMode)) return;
    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest && e.target.closest('[data-nofc-panel]');
      var c = e.target.closest && e.target.closest('[data-nofc-tabs]');
      if (panel && c) showTab(c, panel.getAttribute('data-nofc-panel'));
      var bundle = e.target.closest && e.target.closest('[data-nofc-bundle]');
      if (bundle) selectBundle(Number(bundle.getAttribute('data-nofc-bundle')));
    });
    document.addEventListener('shopify:section:load', function () { init(); });
  }

  function init() {
    state.config = readConfig();
    initBundles();
    initAdd();
    initShip();
    initGallery();
    initVideos();
    initCoa();
    initTabs(document);
    initScroll();
    initSticky();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); initEditor(); });
  else { init(); initEditor(); }
})();
